import {useSelector, TypedUseSelectorHook} from "react-redux";

import type {TRootState} from "types";

const useAppSelector: TypedUseSelectorHook<TRootState> = useSelector;

export default useAppSelector;
